import { z } from 'zod'

/**
 * Matches the POST /hazards/{hazardIdentificationId}/hazard-risk-reduction-steps
 * payload (hazardRiskReductionStepCreatePayloadSchema on the server).
 */
export const createHazardRiskReductionStepFormSchema = z.object({
  riskReductionMeasureId: z.string().min(1, 'Select a risk reduction measure'),
  riskOutInjury: z.string().min(1, 'Required'),
  riskOutFrequency: z.string().min(1, 'Required'),
  riskOutAvoidance: z.string().min(1, 'Required'),
  riskOutLikelihood: z.string().min(1, 'Required'),
  riskOutInjuryJustification: z.string().optional(),
  riskOutFrequencyJustification: z.string().optional(),
  riskOutAvoidanceJustification: z.string().optional(),
  riskOutLikelihoodJustification: z.string().optional(),
})

export type CreateHazardRiskReductionStepFormValues = z.infer<
  typeof createHazardRiskReductionStepFormSchema
>

export const defaultCreateHazardRiskReductionStepFormValues: CreateHazardRiskReductionStepFormValues =
  {
    riskReductionMeasureId: '',
    riskOutInjury: '',
    riskOutFrequency: '',
    riskOutAvoidance: '',
    riskOutLikelihood: '',
    riskOutInjuryJustification: undefined,
    riskOutFrequencyJustification: undefined,
    riskOutAvoidanceJustification: undefined,
    riskOutLikelihoodJustification: undefined,
  }
